import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { graphqlRequest } from "context/graphql/functions";
import { SendRemoteAccessEmailMutationVariables } from "operations/schema/schema";
import { AppAsyncThunkConfig } from "store";
import { State } from "./remoteAccess.store";

export const createAppAsyncThunk = createAsyncThunk.withTypes<AppAsyncThunkConfig>();

export const asyncMutations = {
  sendRemoteAccessEmail: createAppAsyncThunk(
    "remoteAccess/sendRemoteAccessEmail",
    async (props: SendRemoteAccessEmailMutationVariables, { rejectWithValue, extra: { sdk } }) => {
      const { ...variables } = props;
      const { data, errors, queued } = await graphqlRequest(sdk.sendRemoteAccessEmail, {
        thunkName: "remoteAccess/sendRemoteAccessEmail",
        thunkProps: props,
        variables,
      });
      if (errors) return rejectWithValue(errors);
      if (data && !data.sendRemoteAccessEmail) return rejectWithValue("something went wrong");
      return { data, queued };
    },
  ),
};

export const mutationBuilder = (builder: ActionReducerMapBuilder<State>) => {
  builder.addCase(asyncMutations.sendRemoteAccessEmail.pending, (state, { meta }) => {
    if (meta.queued) return state;
    state.loading = true;
    return state;
  });
  builder.addCase(asyncMutations.sendRemoteAccessEmail.rejected, (state, { meta }) => {
    if (meta.aborted) return state;
    state.loading = false;
    return state;
  });
  builder.addCase(asyncMutations.sendRemoteAccessEmail.fulfilled, (state) => {
    state.loading = false;
    return state;
  });
};
